import { User, UserProfile } from './api/users';
import { useQuery } from '@tanstack/react-query';
import { apiGet, apiMonolithGet } from './axios';

const initialUserInfo: User = {
  email: '',
  first_name: '',
  last_name: '',
  full_name: '',
};

const getMyInfo = async (): Promise<User> => {
  const { data } = await apiGet<User>('/accounts/me/');
  if (data && !data.full_name) {
    data.full_name = `${data.first_name} ${data.last_name}`.trim();
  }
  return data;
};

const useUser = () => {
  const { data: userInfo } = useQuery({
    queryKey: ['current-user-info'],
    queryFn: getMyInfo,
  });

  return userInfo ?? initialUserInfo;
};

const getUserProfile = async (): Promise<UserProfile> => {
  const { data } = await apiMonolithGet<UserProfile>('/v2/user-profile/');
  return data;
};

const useUserProfile = (isAuthenticated: boolean) => {
  const { data: userProfile } = useQuery({
    queryKey: ['user-profile'],
    queryFn: getUserProfile,
    enabled: isAuthenticated,
    refetchOnWindowFocus: false,
    retry: 0,
  });

  return userProfile;
};

export { useUser, useUserProfile };
